import type { FaireProductEntity } from "../../entity_types/product";

export const p_cahn2r6jxh: FaireProductEntity = {
  token: "p_cahn2r6jxh",
  type: "product",
  name: "Vera Fairisle Sweater - Fawn",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/95ff2fd6f930a3103c075057713ab333b42654f1c19ae664ecaf5116aa156de5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02b8e696dab8d698ddcc2e32ed3a5632cab61f12f5435e8a2af2f702cdb2ac7a.jpeg",
    "https://cdn.faire.com/fastly/9b89a5542058da16f1020f3533066928ffe4673c8ef28d6b0ab22ab82052df81.jpeg",
    "https://cdn.faire.com/fastly/206236dd289c51973f735dd32de9d10ff128668a0ecd573a0d9c9d4184243c37.jpeg",
    "https://cdn.faire.com/fastly/4e75fe434165f31cb340901b61795edbf2506a6179bc0feca05ab83eba59dc99.jpeg"
  ],
  priceDollars: 116.1,
  description: "A modern nod to a timeless knit tradition. The Vera Fairisle Sweater reimagines a classic motif through graphic patternwork meets ultra-soft alpaca warmth.\n\n• 89% Alpaca 11% Polyamide\n• Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity\n• Classic fit with a subtle crop",
  tags: [],
  msrpDollars: 258,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:25.484Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
